RivalIQ.apps.Discovery.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const MetricView = widgets._GlanceMetricView = RivalIQ.apps.Dashboard.widgets.MetricView.extend({
        regions: {
            sparkline: '.x-sparkline-region'
        },

        behaviors: {
            Titles: RivalIQ.behaviors.Titles
        },

        loadData: function () {
            const me = this;

            const metric = me.dashboardModel.metric;
            const metrics = [metric];

            const submetric = me.dashboardModel.submetric;
            if (submetric) {
                metrics.push(submetric);
            }

            const collection = new RivalIQ.collections.MetricDefinitions(metrics);

            return collection.fetch()
                .done(function (collection) {
                    me.model = collection.at(0);

                    if (submetric) {
                        me.submetric = collection.at(1);
                    }
                });
        }
    });

    const GlanceMetricWidget = widgets._GlanceMetricWidget = RivalIQ.apps.Dashboard.widgets.MetricWidget.extend({

        view: MetricView,

        processProps: function (props) {
            const me = this;

            me.metric = _.extend({}, me.metric, props);

            if (me.submetric) {
                me.submetric = _.extend({}, me.submetric, props);
            }

            return props;
        }
    });
    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.DISCOVERY_METRIC, GlanceMetricWidget);


    const Glance = RivalIQ.apps.Dashboard.views.ColumnWidgets.extend({
        columnWidth: 3,
        panelView: undefined,
        className: 'panel-body',

        dashboardModelEvents: {
            'change': 'reload'
        },

        getPngView: function (child) {
            return child.getView();
        },

        refresh: function () {
            const me = this;
            me.render();
        },

        initialize: function () {
            const me = this;
            me.collection = me.dashboardModel.getWidgets();
        }
    });

    const Widget = RivalIQ.apps.Dashboard.models.Widget;
    const GlanceWidget = widgets._GlanceWidget = Widget.extend({
        title: 'At a Glance',

        view: Glance,
        viewMore: false,

        processProps: function (props) {
            const me = this;

            me.metric = RivalIQ.metric.build(props, me.baseMetric);

            return props;
        },

        description: function () {
            const me = this;
            return RivalIQ.strings[`discovery_${me.getProp('channel')}_glance_description`];
        },

        getFilename: App.utils.getExportFilename,
        getExportTitle: App.utils.exportTitle,
        getExportSubtitle: App.utils.exportSubtitle,
        getPptSubtitle: App.utils.pptSubtitle,

        widgetDefinitions: function () {
            const me = this;

            const metric = me.metric;

            let submetricDisplayString;
            let engagementMetric;
            let breadthMetric;
            let firstMetric;
            let secondMetric;
            let includeSubmetric;

            if (me.getProp('channel') === RivalIQ.enums.channels.INSTAGRAM) {
                submetricDisplayString = RivalIQ.strings.discovery_total_posts_submetric;

                firstMetric = {
                    name: 'Likes / Post',
                    property: 'likes_per_post'
                };

                secondMetric = {
                    name: 'Comments / Post',
                    property: 'comments_per_post'
                };

                engagementMetric = {
                    property: 'engagement_total_per_post'
                };

                breadthMetric = {
                    name: 'Hashtags / Post',
                    property: 'hashtag_count_per_post'
                };
            } else {
                includeSubmetric = true;
                submetricDisplayString = RivalIQ.strings.discovery_total_tweets_submetric;

                firstMetric = {
                    property: 'posts_per_hour'
                };

                secondMetric = {
                    name: 'Unique Users',
                    property: 'unique_users'
                };

                engagementMetric = {
                    property: 'engagement_total_per_post'
                };

                engagementMetric = {
                    name: 'Average Engagement Rate',
                    property: 'avg_engagement_rate_per_post'
                };

                breadthMetric = {
                    name: 'Median User Followers',
                    property: 'median_user_followers'
                };
            }

            const widgetDefinitions = [
                {
                    instanceId: 'tweets-per-hour',
                    widgetId: RivalIQ.enums.widgetTypes.DISCOVERY_METRIC,
                    metric: RivalIQ.metric.build(metric, firstMetric),
                    submetric: includeSubmetric ? RivalIQ.metric.build(metric, {
                        property: 'num_posts',
                        displayString: submetricDisplayString
                    }) : null
                },
                {
                    instanceId: 'unique-users',
                    widgetId: RivalIQ.enums.widgetTypes.DISCOVERY_METRIC,
                    metric: RivalIQ.metric.build(metric, secondMetric),
                    submetric: includeSubmetric ? RivalIQ.metric.build(metric, {
                        property: 'posts_per_user',
                        displayString: function (metricValue) {
                            const postWord = RivalIQ.data.channels.get(me.getProp('channel')).get('postName');
                            return `${metricValue} ${_.upperFirst(postWord)}${parseFloat(metricValue) === 1 ? '/User' : 's/User'}`;
                        }
                    }) : null
                },
                {
                    instanceId: 'avg-engagement-rate-per-post',
                    widgetId: RivalIQ.enums.widgetTypes.DISCOVERY_METRIC,
                    metric: RivalIQ.metric.build(metric, engagementMetric),
                    submetric: includeSubmetric ? RivalIQ.metric.build(metric, {
                        property: 'num_posts',
                        displayString: submetricDisplayString
                    }) : null
                },
                {
                    instanceId: 'median-user-followers',
                    widgetId: RivalIQ.enums.widgetTypes.DISCOVERY_METRIC,
                    metric: RivalIQ.metric.build(metric, breadthMetric),
                    submetric: includeSubmetric ? RivalIQ.metric.build(metric, {
                        property: 'num_posts',
                        displayString: submetricDisplayString
                    }) : null
                }
            ];

            return widgetDefinitions;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.DISCOVERY_GLANCE, GlanceWidget);
});
